import { render, staticRenderFns } from "./SchedaValutazioneEsigenzeImmediateEdit.vue?vue&type=template&id=38a9f78b"
import script from "./SchedaValutazioneEsigenzeImmediateEdit.vue?vue&type=script&lang=js"
export * from "./SchedaValutazioneEsigenzeImmediateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports